// Matches the OpenAPI operationId (case-insensitively) so permission gating can
// resolve `manage_enrolments` from it.
export const API_ENROLMENT_ENTITLEMENTS_INDEX = 'API_ENROLMENT_ENTITLEMENTS_INDEX'
// Internal per-page request action whose success/failure the index saga awaits
// while paginating. Routed through AUTHED_REQUEST so auth/global error handling
// is reused.
export const API_ENROLMENT_ENTITLEMENTS_PAGE = 'API_ENROLMENT_ENTITLEMENTS_PAGE'

export const fetch = () => ({
  type: API_ENROLMENT_ENTITLEMENTS_INDEX,
})
